module.exports = __webpack_public_path__ + "static/media/ai-no-data.2d8e846d.png";